export default "__VITE_ASSET__0xY1w21D__"